import { type CSSProperties, type ReactNode } from 'react';

import { type RequestContext } from '~/types/RequestContext';

import { BettingInsightsComponent } from '../BettingInsightsConfiguration';
import { type BettingInsightsContent, type EsIndex } from '../types';

export interface BettingInsightsMainConfig<TIndex extends EsIndex> {
	alignItems?: CSSProperties['alignItems'];
	render: (
		this: BettingInsightsMain<TIndex>,
		data: {
			content: BettingInsightsContent<TIndex>;
			resourcesUrl: string;
			resultIndex: number;
		},
	) => ReactNode;
}

export class BettingInsightsMain<TIndex extends EsIndex>
	extends BettingInsightsComponent
	implements BettingInsightsMainConfig<TIndex>
{
	alignItems?: CSSProperties['alignItems'];
	render: (data: {
		content: BettingInsightsContent<TIndex>;
		resourcesUrl: string;
		resultIndex: number;
	}) => ReactNode;

	constructor({
		render,
		...requestContext
	}: BettingInsightsMainConfig<TIndex> & RequestContext) {
		super(requestContext);
		this.render = render.bind(this);
	}

	static withRequestContext<TIndex extends EsIndex>(
		requestContext: RequestContext,
		config: BettingInsightsMainConfig<TIndex>,
	) {
		return new this({
			...requestContext,
			...config,
		});
	}
}
